import { Charge } from '@willow/types-iso';

import { add } from '../utils/math';
import { getChargesDue } from './getChargesDue';

/**
 * Gets amount remaining for outstanding charges
 * defaults to not including deferred charges
 */
export function getChargesAmountRemaining<T extends Pick<Charge, 'amountRemaining' | 'status' | 'isDeferred'>>(
  charges: T[],
  includeDeferred = false,
): number {
  const unfulfilledCharges = getChargesDue(charges, includeDeferred);
  return unfulfilledCharges.reduce((a, charge) => add(a, charge.amountRemaining), 0);
}
